import React from 'react';
import './cluePin.css';

const CluePin = ({ solved, onClick }) => (
  <div
    className={`clue-pin ${solved ? 'solved' : 'unsolved'}`}
    onClick={onClick}
    tabIndex={0}
    role="button"
    aria-label={solved ? 'Solved clue' : 'Unsolved clue'}
  >
    <div className="pin-top" />
    <div className="pin-body">
      {solved && <span className="pin-check">✔</span>}
    </div>
  </div>
);

export default CluePin;
